import {
  CreateGUFStartRegistrationTask,
  EditGUFStartRegistrationTask,
} from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { addSchema } from "@/helpers/schema-utils";

import { ENERGY_INSTALLATION_FUNCTION_VALUES } from "../guf-installation-function-helpers";
import { pickGufPrimitiveLibraryFields } from "../guf-schema-primitive-library";

import { designLoopSchema } from "./guf-design-loop-schema";
import { designSurfaceInfiltrationSchema } from "./guf-design-surface-infiltration-schema";
import { designWellSchema } from "./guf-design-well-schema";
import { licensedQuantitySchema } from "./guf-licensed-quantity-schema";

/**
 * Schema for DesignInstallation within a GUF registration.
 * energyCharacteristics is only shown when installationFunction is an energy type.
 *
 */

type DesignInstallation = (
  | CreateGUFStartRegistrationTask
  | EditGUFStartRegistrationTask
)["sourcedocumentData"]["designInstallations"][number];

type DesignInstallationWithoutEnergyCharacteristics = Omit<
  DesignInstallation,
  "energyCharacteristics"
>;

export const designInstallationSchema = addSchema<DesignInstallation[]>({
  type: "array",
  title: "Ontwerpinstallaties",
  items: addSchema<DesignInstallationWithoutEnergyCharacteristics>({
    type: "object",
    title: "Ontwerpinstallatie",
    required: ["designInstallationId", "installationFunction", "designInstallationPos"],
    properties: {
      ...pickGufPrimitiveLibraryFields([
        "designInstallationId",
        "installationFunction",
        "designInstallationPos",
      ]),
      licensedQuantities: licensedQuantitySchema,
      designLoops: designLoopSchema,
      designSurfaceInfiltrations: designSurfaceInfiltrationSchema,
      designWells: designWellSchema,
    },
    allOf: [
      {
        if: {
          properties: {
            installationFunction: {
              enum: [...ENERGY_INSTALLATION_FUNCTION_VALUES],
            },
          },
          required: ["installationFunction"],
        },
        then: {
          properties: pickGufPrimitiveLibraryFields(["energyCharacteristics"]),
        },
      },
    ],
  }),
  // Because the energyCharacteristics is conditionally required, we need to cast the schema to SchemaForFormData<DesignInstallation[]> to ensure the type is correct.
  // We do however type all the other fields in the schema and the energyCharacteristics itself so this as assertion is not harmfull
} as SchemaForFormData<DesignInstallation[]>);
